import DOMPurify from "dompurify";

// Sanitized links and other targeted elements always open in a new tab.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
	if ("target" in node) {
		node.setAttribute("target", "_blank");
		node.setAttribute("rel", "noopener");
	}
});
